module.exports = __webpack_public_path__ + "img/company3.db25dbe3.png";